import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import AnimeCard from "@/components/feature/AnimeCard";
import { getPopular } from "@/utils/anime";

export default function NotFound() {
  const location = useLocation();
  const recommend = getPopular(4);

  usePageMeta({
    title: "页面不存在 - 色情动漫",
    description: "你访问的页面不存在或已经被移动，可以返回首页继续浏览成人向动画作品资料。",
    keywords: "色情动漫,404,页面不存在",
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />

      <main className="flex-1 w-full">
        <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-10 items-center">
            <div>
              <p className="font-label text-7xl md:text-9xl text-primary-800 leading-none select-none">404</p>
              <h1 className="mt-6 font-heading text-2xl md:text-3xl text-foreground-950">这个页面不在这里</h1>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg leading-relaxed">
                链接可能已经失效，或者页面地址有误。你可以回到首页，或从分类页继续找想看的作品。
              </p>
              <p className="mt-3 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to="/"
                  className="h-10 px-5 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 text-sm flex items-center gap-2 transition-colors whitespace-nowrap"
                >
                  <i className="ri-home-4-line" />
                  返回首页
                </Link>
                <Link
                  to="/category"
                  className="h-10 px-5 rounded-md border border-background-400/60 text-foreground-700 hover:text-accent-400 hover:border-accent-500/70 text-sm flex items-center gap-2 transition-colors whitespace-nowrap"
                >
                  <i className="ri-layout-grid-line" />
                  浏览分类
                </Link>
                <Link
                  to="/search"
                  className="h-10 px-5 rounded-md border border-background-400/60 text-foreground-700 hover:text-accent-400 hover:border-accent-500/70 text-sm flex items-center gap-2 transition-colors whitespace-nowrap"
                >
                  <i className="ri-search-line" />
                  搜索作品
                </Link>
              </div>
            </div>

            <div className="rounded-lg border border-background-300/50 bg-background-100/60 p-5">
              <h2 className="text-sm text-foreground-900 tracking-wide mb-4">不如看看这些热门作品</h2>
              <div className="grid grid-cols-2 gap-x-4 gap-y-6">
                {recommend.map((item) => (
                  <AnimeCard key={item.id} anime={item} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}